import * as React from 'react';
const Cpu = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-cpu", ...props },
    React.createElement("rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", ry: "2" }),
    React.createElement("rect", { x: "9", y: "9", width: "6", height: "6" }),
    React.createElement("line", { x1: "9", y1: "1", x2: "9", y2: "4" }),
    React.createElement("line", { x1: "15", y1: "1", x2: "15", y2: "4" }),
    React.createElement("line", { x1: "9", y1: "20", x2: "9", y2: "23" }),
    React.createElement("line", { x1: "15", y1: "20", x2: "15", y2: "23" }),
    React.createElement("line", { x1: "20", y1: "9", x2: "23", y2: "9" }),
    React.createElement("line", { x1: "20", y1: "14", x2: "23", y2: "14" }),
    React.createElement("line", { x1: "1", y1: "9", x2: "4", y2: "9" }),
    React.createElement("line", { x1: "1", y1: "14", x2: "4", y2: "14" })));
export default Cpu;
//# sourceMappingURL=Cpu.js.map